import React from "react";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { LoadingCarrinhoContainer } from "./styles";

interface LoadingCarrinhoProps {
  mensagem?: string;
  subMensagem?: string;
  position?: "absolute" | "fixed";
}

const LoadingCarrinho: React.FC<LoadingCarrinhoProps> = ({
  mensagem,
  subMensagem,
  position = "absolute",
}) => {
  const { theme } = useTheme();

  return (
    <LoadingCarrinhoContainer theme={theme} position={position}>
      <div className="componente-carregando-pagina">
        <div className="carrinho-container">
          <svg
            id="Camada_1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 963.78 963.78"
            width="200"
            style={{ maxWidth: "100px", height: "auto" }}
          >
            <style>
              {`
                .st0 {
                  fill: #2A844E;
                }

                .carrinho-animado {
                  animation: loopCarrinho2 4s linear infinite;
                  transform-origin: center;
                }

                .carrinho-animado2 {
                  animation: loopCarrinho2 3s linear infinite;
                }

                @keyframes loopCarrinho2 {
                  0% {
                    transform: translateX(-500px) rotate(0deg);
                  }
                  100% {
                    transform: translateX(700px) rotate(0deg);
                  }
                }
              `}
            </style>
            <defs>
              <clipPath id="clip-circulo">
                <circle cx="481.89" cy="481.89" r="380" />
              </clipPath>
            </defs>

            <circle
              cx="481.89"
              cy="481.89"
              r="380"
              fill="none"
              stroke="#2A844E"
              strokeWidth="40"
            />
            <g clipPath="url(#clip-circulo)">
              <g className="carrinho-animado2" transform="translate(650,260)">
                <path
                  className="st0"
                  d="M467.61,516.76l-33.45-182.43c-1.08-7-5.96-12.97-12.69-15.56l-56.79-22.4
c-10.4-4.16-22.27,1.02-26.48,11.53c-2.05,5.12-1.95,10.7.28,15.71c2.19,4.92,6.18,8.74,11.29,10.78l46.26,18.21l34.51,187.94
c1.31,7.86,7.25,14.14,14.71,16.23l-9.5,26.71c-2.23,5.58-1.4,12.06,2.18,16.96c2.46,3.59,6.06,6.12,10.13,7.25
c-2.25,5.38-3.43,11.05-3.43,16.73c0,24.73,20.12,44.85,44.85,44.85s44.85-20.12,44.85-44.85c0-5.61-1.02-11.05-2.96-16.08h50.6
c-2.08,5.19-3.17,10.64-3.17,16.08c0,24.73,20.12,44.85,44.85,44.85s44.84-20.12,44.84-44.85c0-5.72-1.05-11.25-3.07-16.36  
c8.67-1.5,15.06-8.89,15.06-18.05c0-10.28-8.05-18.33-18.33-18.33H443.61l5.11-14.17h178.27c9.01,0,16.86-5.75,19.51-14.24
l50.88-158.94c1.68-5.63.55-12.06-3.04-17.18c-3.57-5.1-9.23-8.32-15.53-8.85l-235.78-10.1c-11.17-.54-20.7,8.22-21.24,19.51
c-.26,5.43,1.67,10.64,5.43,14.68c3.7,3.97,8.7,6.3,14.11,6.56l209.26,9.01l-38.12,118.81h-179.71Z"
                />

                <path
                  d="M615.14,624.75c0-4.44,3.75-8.19,8.19-8.19s8.19,3.75,8.19,7.91c-.16,4.75-3.76,8.47-8.19,8.47
s-8.19-3.75-8.19-8.19Z"
                  fill="#1e4826"
                  strokeWidth="40"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                <path
                  d="M480.98,624.75c0-4.44,3.75-8.19,8.19-8.19s8.19,3.75,8.19,7.91c-.16,4.75-3.76,8.47-8.19,8.47
s-8.19-3.75-8.19-8.19Z"
                  fill="#1e4826"
                  strokeWidth="40"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                <path
                  className="st0"
                  d="M232.37,552.19c-9.91,0-17.96,8.06-17.96,17.96s8.06,17.97,17.96,17.97h142.62c9.91,0,17.97-8.06,17.97-17.97
s-8.06-17.96-17.97-17.96H232.37Z"
                />
                <path
                  className="st0"
                  d="M260.85,451.56c0,9.91,8.06,17.96,17.96,17.96h64.42c9.91,0,17.97-8.06,17.97-17.96
s-8.06-17.97-17.97-17.97h-64.42c-9.91,0-17.96,8.06-17.96,17.97Z"
                />
                <path
                  className="st0"
                  d="M274.61,503.24c0-9.9-8.06-17.96-17.97-17.96h-90.79c-9.91,0-17.97,8.06-17.97,17.96
s8.06,17.96,17.97,17.96h90.79c9.91,0,17.97-8.06,17.97-17.96Z"
                />
              </g>
            </g>
          </svg>
        </div>
        {mensagem && <div className="mensagem">{mensagem}</div>}
        {subMensagem && <div className="sub-mensagem">{subMensagem}</div>}
      </div>
    </LoadingCarrinhoContainer>
  );
};

export default LoadingCarrinho;
